<template>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M16.6 5.248h2.454l-5.36 6.143L20 19.752h-4.937l-3.87-5.07-4.422 5.07H4.313l5.733-6.572L4 5.248h5.062l3.494 4.633zm-.863 13.033h1.36L8.322 6.642h-1.46z"/></svg>

</template>